<template>
    <div>
      <div v-if="toneOfContent || author || brand">
        Set
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not set
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewTone',
    props: [
        'toneOfContent',
        'author',
        'brand',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>